/*
	AUTHOR: Osvaldas Valutis, www.osvaldas.info

	https://www.jqueryscript.net/other/Clean-Audio-Player-jQuery.html
*/

import $ from "jquery";

var isTouch = "ontouchstart" in window,
  eStart = isTouch ? "touchstart" : "mousedown",
  eMove = isTouch ? "touchmove" : "mousemove",
  eCancel = isTouch ? "touchcancel" : "mouseup",
  secondsToTime = function (secs) {
    var hours = Math.floor(secs / 3600),
      minutes = Math.floor((secs % 3600) / 60),
      seconds = Math.floor((secs % 3600) % 60);
    const hours_str =
      hours === 0
        ? ""
        : (hours > 0 && hours.toString().length < 2 ? "0" + hours : hours) +
          ":";
    const minutes_str = minutes.toString().length < 2 ? "0" + minutes : minutes;
    const seconds_str = seconds.toString().length < 2 ? "0" + seconds : seconds;
    return hours_str + minutes_str + ":" + seconds_str;
  };

export const changeAudio = (audio_id, durationSeconds, setCurrentTime) => {
  var cssClassSub = {
      playPause: "playpause",
      playing: "playing",
      time: "time",
      timeCurrent: "time-current",
      timeDuration: "time-duration",
      bar: "bar",
      barLoaded: "bar-loaded",
      barPlayed: "bar-played",
      volume: "volume",
      volumeButton: "volume-button",
      volumeAdjust: "volume-adjust",
      noVolume: "novolume",
      mute: "mute",
      mini: "mini",
    },
    cssClass = {};

  for (var subName in cssClassSub)
    cssClass[subName] = "audioplayer-" + cssClassSub[subName];

  var thePlayer = $(".audioplayer"),
    $audio = $("#" + audio_id),
    audioFile = $audio.attr("src");

  if (!audioFile) {
    console.error("No audio file specified.");
    return;
  }


  var theAudio = $audio.get(0);

  if (!theAudio) {
    console.error("Audio element not found.");
    return;
  }

  // UI Elements
  var theBar = thePlayer.find("." + cssClass.bar),
    barPlayed = thePlayer.find("." + cssClass.barPlayed),
    barLoaded = thePlayer.find("." + cssClass.barLoaded),
    timeCurrent = thePlayer.find("." + cssClass.timeCurrent),
    timeDuration = thePlayer.find("." + cssClass.timeDuration),
    volumeButton = thePlayer.find("." + cssClass.volumeButton),
    volumeAdjuster = thePlayer.find("." + cssClass.volumeAdjust + " > div"),
    volumeDefault = theAudio.volume;

  // Helper Functions
  var adjustCurrentTime = function (e) {
    const theRealEvent = isTouch ? e.originalEvent.touches[0] : e;
    const newTime = Math.round(
      (durationSeconds * (theRealEvent.pageX - theBar.offset().left)) /
        theBar.width()
    );
    theAudio.currentTime = newTime;
  };

  var adjustVolume = function (e) {
    const theRealEvent = isTouch ? e.originalEvent.touches[0] : e;
    const newVolume = Math.abs(
      (theRealEvent.pageX - volumeAdjuster.offset().left) /
        volumeAdjuster.width()
    );
    theAudio.volume = newVolume;
  };

  // Initialize UI
  barPlayed.width(0);
  timeDuration.text(secondsToTime(durationSeconds));
  timeCurrent.text(secondsToTime(0));

  // Event Handlers
  var loadedDataFunc = function () {
    volumeAdjuster.find("div").width(theAudio.volume * 100 + "%");
  };

  var timeUpdateFunc = function () {
    const currentTime = theAudio.currentTime;
    timeCurrent.text(secondsToTime(currentTime));
    barPlayed.width((currentTime / durationSeconds) * 100 + "%");
    if (currentTime >= durationSeconds) {
      barPlayed.width("100%");
    }
    setCurrentTime(currentTime);
  };

  var volumeChangeFunc = function () {
    volumeAdjuster.find("div").width(theAudio.volume * 100 + "%");
    if (theAudio.volume > 0 && thePlayer.hasClass(cssClass.mute))
      thePlayer.removeClass(cssClass.mute);
    if (theAudio.volume <= 0 && !thePlayer.hasClass(cssClass.mute))
      thePlayer.addClass(cssClass.mute);
  };

  var endedFunc = function () {
    thePlayer.removeClass(cssClass.playing);
  };

  var barOnEstartFunc = function (e) {
    adjustCurrentTime(e);
    theBar.on(eMove, adjustCurrentTime);
  };

  var barOnEcancelFunc = function () {
    theBar.off(eMove, adjustCurrentTime);
  };

  var volumeButtonOnClickFunc = function () {
    if (thePlayer.hasClass(cssClass.mute)) {
      thePlayer.removeClass(cssClass.mute);
      theAudio.volume = volumeDefault;
    } else {
      thePlayer.addClass(cssClass.mute);
      volumeDefault = theAudio.volume;
      theAudio.volume = 0;
    }
    return false;
  };

  var volumeAdjusterOnEstartFunc = function (e) {
    adjustVolume(e);
    volumeAdjuster.on(eMove, adjustVolume);
  };

  var volumeAdjusterOnEcansel = function () {
    volumeAdjuster.off(eMove, adjustVolume);
  };

  var playerIconOnClickFunc = function () {
    if (thePlayer.hasClass(cssClass.playing)) {
      thePlayer.removeClass(cssClass.playing);
      theAudio.pause();
    } else {
      thePlayer.addClass(cssClass.playing);
      theAudio.play();
    }
    return false;
  };

  // Attach Event Listeners
  theAudio.addEventListener("loadeddata", loadedDataFunc);
  theAudio.addEventListener("timeupdate", timeUpdateFunc);
  theAudio.addEventListener("volumechange", volumeChangeFunc);
  theAudio.addEventListener("ended", endedFunc);

  theBar.on(eStart, barOnEstartFunc).on(eCancel, barOnEcancelFunc);
  volumeButton.on("click", volumeButtonOnClickFunc);
  volumeAdjuster
    .on(eStart, volumeAdjusterOnEstartFunc)
    .on(eCancel, volumeAdjusterOnEcansel);

  thePlayer.find("." + cssClass.playPause).on("click", playerIconOnClickFunc);

  // return function for before unmount parent component
  return () => {
    theAudio.removeEventListener("loadeddata", loadedDataFunc);
    theAudio.removeEventListener("timeupdate", timeUpdateFunc);
    theAudio.removeEventListener("volumechange", volumeChangeFunc);
    theAudio.removeEventListener("ended", endedFunc);
    theBar?.off(eStart, barOnEstartFunc);
    theBar?.off(eCancel, barOnEcancelFunc);
    theBar?.off(eMove, (e) => adjustCurrentTime(e));
    theBar?.off("mouseleave", barOnEcancelFunc);
    volumeButton?.off("click", volumeButtonOnClickFunc);
    volumeAdjuster?.off(eStart, volumeAdjusterOnEstartFunc);
    volumeAdjuster?.off(eCancel, volumeAdjusterOnEcansel);
    thePlayer
      .find("." + cssClass.playPause)
      ?.off("click", playerIconOnClickFunc);
  };
};
